import { config } from "@neru/base/config";
import { useAuth, useUserAccounts } from "@neru/base/hooks";
import {
  AuthServiceProvider,
  CookieSessionProvider,
} from "@neru/base/services";
import { type MFAAccountProps } from "@neru/base/types";
import { getLogger, mapApiRoute } from "@neru/base/utils";
import type { WithChildren } from "@neru/types";
import { Spinner } from "@neru/ui";
import { useEffect } from "react";

const log = getLogger("IdentityAwareProxy");

const authService = new CookieSessionProvider(
  mapApiRoute(config.graphqlApiUrl),
);

const WithUserAccounts = ({
  accountId,
  apiKeys,
  children,
}: WithChildren & MFAAccountProps) => {
  const { saveAccountId } = useAuth();

  const { loading } = useUserAccounts(apiKeys);

  useEffect(() => {
    if (new AuthServiceProvider(authService)) {
      log.info("Auth service provider is initialized.");
    }
  }, []);

  useEffect(() => {
    saveAccountId(accountId);
  }, [accountId, saveAccountId]);

  if (loading) {
    return <Spinner data-testid="user-accounts" />;
  }

  return children;
};

const WithAuth = ({
  accountId,
  apiKeys,
  children,
}: WithChildren & MFAAccountProps) => (
  <WithUserAccounts accountId={accountId} apiKeys={apiKeys}>
    {children}
  </WithUserAccounts>
);

export default WithAuth;
